<template>
  <footer class="text-white px-3 md:px-8 py-6 xl:container xl:mx-auto">
    <div class="py-1 md:py-16">
      <div class="flex w-full justify-between flex-col md:flex-row flex-wrap">
        <LinkGroup heading="Protection" :items="protectionItems" />
        <LinkGroup heading="Solutions" :items="solutionsItems" />
        <LinkGroup heading="Bug bounty" :items="bugBountyItems" />
        <LinkGroup heading="Resources" :items="resourcesItems" />
        <LinkGroup heading="Patchstack" :items="patchstackItems" />
      </div>
    </div>
    <div
      class="flex flex-col md:flex-row justify-between align-middle md:border-t md:border-darken md:border-opacity-10 pb-2 pt-8 md:pb-8"
    >
      <BaseLink to="/" aria-label="Go to homepage">
        <Logo />
      </BaseLink>
      <Terms />
    </div>
  </footer>
</template>
<script setup>
  const protectionItems = [
    { label: 'Pricing', url: 'https://patchstack.com/pricing/' },
    {
      label: 'Wordpress',
      url: 'https://patchstack.com/wordpress-security/'
    },
    {
      label: 'For agencies',
      url: 'https://patchstack.com/for-agencies/'
    },
    {
      label: 'Documentation',
      url: 'https://docs.patchstack.com/docs/introduction'
    }
  ];

  const solutionsItems = [
    {
      label: 'WordPress security',
      url: 'https://patchstack.com/wordpress-security/'
    },
    {
      label: 'Plugin auditing',
      url: 'https://patchstack.com/auditing/'
    },
    {
      label: 'Managed VDP',
      url: 'https://patchstack.com/for-plugins/'
    },
    {
      label: 'Bug bounty',
      url: 'https://patchstack.com/bug-bounty/'
    },
    {
      label: 'Intelligence (API)',
      url: 'https://patchstack.com/threat-intel-feed/'
    }
  ];

  const bugBountyItems = [
    {
      label: 'Leaderboard',
      url: 'https://patchstack.com/database/leaderboard/'
    },
    {
      label: 'Security programs',
      url: 'https://patchstack.com/database/vdp/'
    },
    {
      label: 'Guidelines',
      url: 'https://patchstack.com/articles/bug-bounty-guidelines-rules/'
    },
    {
      label: 'Report',
      url: 'https://patchstack.com/database/report/'
    }
  ];

  const resourcesItems = [
    {
      label: 'Vulnerability Database',
      url: 'https://patchstack.com/database/'
    },
    {
      label: 'Vulnerability Statistics',
      url: 'https://patchstack.com/database/statistics/wordpress'
    },
    {
      label: 'Whitepaper 2022',
      url: 'https://patchstack.com/whitepaper/wordpress-security-stats-2022/?utm_source=website&utm_medium=db-banner&utm_campaign=whitepaper2022'
    },
    {
      label: 'Articles',
      url: 'https://patchstack.com/articles/'
    },
    {
      label: 'Join Discord',
      url: 'https://discord.com/invite/V9AE9zczhv'
    }
  ];

  const patchstackItems = [
    { label: 'About', url: 'https://patchstack.com/about/' },
    {
      label: 'Store',
      url: 'https://store.patchstack.com/',
      badge: 'New'
    },
    {
      label: 'Careers',
      url: 'https://patchstack.com/about/#careers'
    },
    {
      label: 'Media kit',
      url: 'https://drive.google.com/drive/u/2/folders/1VlVbJnh8nBTVtJGvuo8KjAOgstBWxQ_W'
    },
    {
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/company/patchtsack/'
    },
    {
      label: 'Facebook',
      url: 'https://www.facebook.com/groups/patchstackcommunity/'
    },
    { label: 'X', url: 'https://twitter.com/patchstackapp/' }
  ];
</script>
